import axiosInstance from './api'
import {
	fixtureFetchApplications,
	fixtureFetchStudentApplications,
	shouldUseApplicationFlowFixtures,
} from 'fixtures/applicationFlowFixtures'

/**
 * Fetch applications from wishlist (shortlists)
 */
export const fetchApplications = async () => {
	if (shouldUseApplicationFlowFixtures()) return fixtureFetchApplications()

	try {
		const response = await axiosInstance.get('/counseling/applications')
		return response.data || {}
	} catch (error) {
		console.error('Error fetching applications:', error)
		throw error
	}
}

/**
 * Fetch applications for a specific student (universities from wishlist)
 * @param {string|number} studentId - Student ID
 * @returns {Promise<object>} API payload with `applications` array
 */
/** Counselor opened application (list expand or details) — clears NEW badge on next fetch. */
export const markApplicationSeen = async targetId => {
	const id = String(targetId || '').trim()
	if (!id) {
		throw new Error('Invalid application target id')
	}
	try {
		const response = await axiosInstance.post(
			`/counseling/applications/${encodeURIComponent(id)}/seen`,
		)
		return response.data || {}
	} catch (error) {
		console.error('Error marking application seen:', error)
		throw error
	}
}

export const patchApplicationTargetStatus = async (targetId, status) => {
	const id = String(targetId || '').trim()
	if (!id) {
		throw new Error('Invalid application target id')
	}
	try {
		const response = await axiosInstance.patch(
			`/counseling/applications/${encodeURIComponent(id)}/status`,
			{ status: String(status || '').trim() },
		)
		return response.data || {}
	} catch (error) {
		console.error('Error updating application status:', error)
		throw error
	}
}

export const fetchStudentApplications = async studentId => {
	const normalizedId = String(studentId || '').trim()
	if (!normalizedId) {
		throw new Error('Invalid studentId: empty or null')
	}

	if (shouldUseApplicationFlowFixtures()) {
		return fixtureFetchStudentApplications(normalizedId)
	}

	try {
		const encodedId = encodeURIComponent(normalizedId)
		const response = await axiosInstance.get(
			`/counseling/applications?studentId=${encodedId}`,
		)
		return response.data || {}
	} catch (error) {
		console.error('Error fetching student applications:', error)
		throw error
	}
}
